// @flow
import Cache from "../../utils/browser/Cache";

import type { Reducer } from "redux";
import type { ReduxAction, ModelCatalogState } from "../types";

const initialState: ModelCatalogState = {
  entryDate: new Date().toISOString().split("T")[0],
};

/**
 * Keep track of the entry date for the modelcatalog
 */
const ModelCatalogReducer: Reducer<ModelCatalogState, ReduxAction> = (
  state = initialState,
  action,
) => {
  if (!action) {
    return state;
  }

  if (action.type === "UPDATE_ENTRYDATE") {
    Cache.addItem("ModelCatalogEntryDate", action.payload);
    return {
      ...state,
      entryDate: action.payload,
    };
  }

  return state;
};

export default ModelCatalogReducer;
